module.exports = __webpack_public_path__ + "img/gift7-06-c1.dca0f8a4.png";